var _circle, _rect, _mask, _rect2, _path, _mask2, _rect3;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgTech(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 48 48",
    fill: "none"
  }, props), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 24,
    cy: 24,
    r: 24,
    fill: "#FAEFF0"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 13,
    y: 13,
    width: 22,
    height: 22,
    rx: 3,
    stroke: "#E47B5B",
    strokeWidth: 2
  })), _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
    id: "tech_svg__path-3-inside-1",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 18,
    y: 18,
    width: 12,
    height: 12,
    rx: 1
  }))), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 18,
    y: 18,
    width: 12,
    height: 12,
    rx: 1,
    stroke: "#E47B5B",
    strokeWidth: 4,
    mask: "url(#tech_svg__path-3-inside-1)"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22 16v2m4-2v2M22 30v2m4-2v2M16 22h2m-2 4h2M30 22h2m-2 4h2",
    stroke: "#E47B5B",
    strokeWidth: 2
  })), _mask2 || (_mask2 = /*#__PURE__*/React.createElement("mask", {
    id: "tech_svg__path-8-inside-2",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 4,
    height: 4,
    rx: 1,
    transform: "matrix(-1 0 0 1 26 22)"
  }))), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    width: 4,
    height: 4,
    rx: 1,
    transform: "matrix(-1 0 0 1 26 22)",
    stroke: "#E47B5B",
    strokeWidth: 4,
    mask: "url(#tech_svg__path-8-inside-2)"
  })));
}

export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iNDgiIGhlaWdodD0iNDgiIHZpZXdCb3g9IjAgMCA0OCA0OCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPGNpcmNsZSBjeD0iMjQiIGN5PSIyNCIgcj0iMjQiIGZpbGw9IiNGQUVGRjAiLz4KPHJlY3QgeD0iMTMiIHk9IjEzIiB3aWR0aD0iMjIiIGhlaWdodD0iMjIiIHJ4PSIzIiBzdHJva2U9IiNFNDdCNUIiIHN0cm9rZS13aWR0aD0iMiIvPgo8bWFzayBpZD0icGF0aC0zLWluc2lkZS0xIiBmaWxsPSJ3aGl0ZSI+CjxyZWN0IHg9IjE4IiB5PSIxOCIgd2lkdGg9IjEyIiBoZWlnaHQ9IjEyIiByeD0iMSIvPgo8L21hc2s+CjxyZWN0IHg9IjE4IiB5PSIxOCIgd2lkdGg9IjEyIiBoZWlnaHQ9IjEyIiByeD0iMSIgc3Ryb2tlPSIjRTQ3QjVCIiBzdHJva2Utd2lkdGg9IjQiIG1hc2s9InVybCgjcGF0aC0zLWluc2lkZS0xKSIvPgo8cGF0aCBkPSJNMjIgMTZWMThNMjYgMTZWMTgiIHN0cm9rZT0iI0U0N0I1QiIgc3Ryb2tlLXdpZHRoPSIyIi8+CjxwYXRoIGQ9Ik0yMiAzMFYzMk0yNiAzMFYzMiIgc3Ryb2tlPSIjRTQ3QjVCIiBzdHJva2Utd2lkdGg9IjIiLz4KPHBhdGggZD0iTTE2IDIySDE4TTE2IDI2SDE4IiBzdHJva2U9IiNFNDdCNUIiIHN0cm9rZS13aWR0aD0iMiIvPgo8cGF0aCBkPSJNMzAgMjJIMzJNMzAgMjZIMzIiIHN0cm9rZT0iI0U0N0I1QiIgc3Ryb2tlLXdpZHRoPSIyIi8+CjxtYXNrIGlkPSJwYXRoLTgtaW5zaWRlLTIiIGZpbGw9IndoaXRlIj4KPHJlY3Qgd2lkdGg9IjQiIGhlaWdodD0iNCIgcng9IjEiIHRyYW5zZm9ybT0ibWF0cml4KC0xIDAgMCAxIDI2IDIyKSIvPgo8L21hc2s+CjxyZWN0IHdpZHRoPSI0IiBoZWlnaHQ9IjQiIHJ4PSIxIiB0cmFuc2Zvcm09Im1hdHJpeCgtMSAwIDAgMSAyNiAyMikiIHN0cm9rZT0iI0U0N0I1QiIgc3Ryb2tlLXdpZHRoPSI0IiBtYXNrPSJ1cmwoI3BhdGgtOC1pbnNpZGUtMikiLz4KPC9zdmc+Cg==";
export { SvgTech as ReactComponent };